<script>
  import fileTemplateState from "../../stores/fileTemplateJsonData"
  import TextEditorMenu from "./textEditorMenu.svelte"
  import ImageEditorMenu from "./imageEditorMenu.svelte"
  import LayerDelete from "../modules/layerDelete/index.svelte"
  import notify from "../../../../../Script/notify"
  let deleteSingleLayer = false
  let LayerDeleteObj = {}
  let closeNotification = {
    close() {},
  }
  const showActiveComponent = (id, active, type) => {
    $fileTemplateState.operations = $fileTemplateState.operations.map((operation) => {
      operation.active = false
      if (operation.errorX || operation.errorY) operation.move = true

      if (active) {
        operation.active = false
        $fileTemplateState.notifyFooter = "Layer Closed"
        $fileTemplateState.footerArray = ["You can change the quality in settings", "Add or Edit, Text, Image and qr elements", "You can Add custom fonts for text layers", "You can Able to change File template name", "Able to Download the canvas"]
      } else {
        operation.active = operation.id == id

        $fileTemplateState.notifyFooter = "Layer Opened"

        if (type == "text") {
          $fileTemplateState.footerArray = ["You can change the Layer Name and Value", "You can apply different font families", "Apply color on your wish", "Apply font styles based on your interest", "Able to move and drag the text"]
        } else if (type == "image") {
          $fileTemplateState.footerArray = ["You can able to change the Layer Name", "Able to toggle static/dynamic", "Able to move and drag the image", "Able to maintain the aspect ratio of the image"]
        } else {
          $fileTemplateState.footerArray = ["Able to move and drag the qr", "Able to maintain the aspect ratio of the qr"]
        }
      }
      return operation
    })
  }

  // deelte single layer
  const deleteLayer = () => {
    closeNotification.close()
    $fileTemplateState.operations = $fileTemplateState.operations.filter((deleted) => deleted.id != LayerDeleteObj.id)
    deleteSingleLayer = false

    closeNotification = notify.info(`${LayerDeleteObj.attribute} layer was deleted successfully!`)
    LayerDeleteObj = {}
  }

  const clickToScrollView = (id) => {
    document.getElementById(id).scrollIntoView(true)
  }
</script>

{#if deleteSingleLayer}
  <LayerDelete
    on:deleteLayer={deleteLayer}
    on:click={() => {
      deleteSingleLayer = false
    }}
    attribute={LayerDeleteObj.attribute}
  />
{/if}

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<div class="relative flex w-[397px] flex-col gap-3 overflow-x-hidden overflow-y-scroll rounded-md pr-2">
  {#each $fileTemplateState.operations as operation}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      on:click|stopPropagation={() => {
        showActiveComponent(operation.id, operation.active, operation.type)
        clickToScrollView(operation.id)

        try {
          if (operation.errorX || operation.errorY) throw `Fix the layers marked with Exclamation icon as they are out of bounds.`
        } catch (error) {
          closeNotification.close()
          const info = "PAGE: File template Editor (Layers)\nEVENT: While toggling active state of layer"
          closeNotification = notify.danger(error, info)
        }
      }}
      on:mouseover={() => {
        operation.hover = true
      }}
      on:mouseleave={() => {
        operation.hover = false
      }}
      class="flex w-full cursor-pointer {operation.errorX || operation.errorY ? 'bg-red-500' : ''} items-center bg-[#292A2F] {operation.hover && operation.active ? ' bg-blue-400' : ''} {operation.hover && !operation.active ? ' bg-blue-400' : ''} justify-between rounded-md p-3 {operation.active && !operation.hover ? ' bg-blue-500' : ''}"
      id={operation.id}
    >
      <div class="flex w-full items-center text-white">
        <div class="flex w-2/12 items-center justify-center">
          {#if operation.type == "text"}
            <i class="fa-solid fa-text" />
          {:else if operation.type == "image" && !operation.dynamic && !operation.image}
            <i class="fa-solid fa-image" />
          {:else if operation.type == "image" && !operation.dynamic && operation.image}
            <img src={operation.image.src} alt="icon" class="h-10 w-10 rounded-full border-2 object-cover {operation.active ? 'bg-black' : 'border-blue-500'} p-1" />
          {:else if operation.type == "image" && operation.dynamic}
            <i class="fa-solid fa-image" />
          {:else}
            <i class="fa-solid fa-qrcode" />
          {/if}
        </div>
        <div class="flex w-10/12 items-center justify-between">
          <div class="flex w-10/12 items-center gap-3">
            <span class="truncate text-lg font-medium tracking-wide text-white">
              {operation.attribute}
            </span>
            <div>
              {#if operation.errorX || operation.errorY}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="h-8 w-8">
                  <!-- Background Triangle -->
                  <path fill="#FFD43B" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32z" />
                  <!-- Exclamation Mark -->
                  <path fill="#000000" d="M256 160c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24v-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
                </svg>
              {/if}
            </div>
          </div>

          <button
            data-tooltip="Delete"
            tooltip-position="left"
            on:click|stopPropagation={() => {
              deleteSingleLayer = true
              LayerDeleteObj = { attribute: operation.attribute, id: operation.id }
            }}
            class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-white {operation.errorX || operation.errorY ? 'hover:bg-black' : 'hover:bg-blue-600'}"
          >
            <i class="fa-solid fa-trash-can" />
          </button>
        </div>
      </div>
    </div>
    {#if operation.active}
      <svelte:component
        this={operation.type == "text" ? TextEditorMenu : ImageEditorMenu}
        bind:operation
        on:keydown={(event) => {
          if (event.key === "Delete") {
            deleteSingleLayer = true
            LayerDeleteObj = { attribute: operation.attribute, id: operation.id }
          }
          if (event.target.nodeName == "BODY") {
            let step = event.ctrlKey ? 10 : 1
            if (event.key === "ArrowRight" || event.key === "ArrowLeft" || event.key === "ArrowUp" || event.key === "ArrowDown") {
              event.preventDefault()
            }
            if (event.key === "ArrowRight") {
              operation.x = operation.x + step
            } else if (event.key === "ArrowLeft") {
              operation.x = operation.x - step
            } else if (event.key === "ArrowUp") {
              operation.y = operation.y - step
              operation.inputY = operation.inputY + step
            } else if (event.key === "ArrowDown") {
              operation.y = operation.y + step
              operation.inputY = operation.inputY - step
            }
          }
          $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
            if (opp.type == "text") {
              opp.errorX = opp.x < 0 || opp.x > $fileTemplateState.baseImageInfo.width
              opp.errorY = opp.y < 0 || opp.y > $fileTemplateState.baseImageInfo.height
            } else {
              opp.errorX = opp.x < 0 || opp.x + opp.width > $fileTemplateState.baseImageInfo.width
              opp.errorY = opp.y < 0 || opp.y + opp.height > $fileTemplateState.baseImageInfo.height
            }
            return opp
          })
        }}
      />
    {/if}
  {/each}
</div>
